import React from 'react';
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import { Box, Flex } from '@chakra-ui/react';

const MotionFlex = motion(Flex);

const projectVariants = {
  hidden: {
    pathLength: 0,
  },
  visible: {
    pathLength: 1,
    transition: {
      duration: 2.5,
    },
  },
};

export const ProjectsSvg = () => {
  const { scrollY } = useViewportScroll();

  const scale = useTransform(scrollY, [0, 400], [1, 2]);

  const rotateRight = useTransform(scrollY, [0, 400], [0, 180]);
  const rotateLeft = useTransform(scrollY, [0, 400], [0, -270]);

  const opacity = useTransform(scrollY, [0, 400], [1, -0.2]);

  const xRight = useTransform(scrollY, [0, 400], [0, 150]);
  const xLeft = useTransform(scrollY, [0, 400], [0, -150]);
  const y = useTransform(scrollY, [0, 400], [0, 200]);

  return (
    <MotionFlex
      className="projects"
      width={{ base: 48, md: 64 }}
      height="auto"
      justifyContent="center"
      alignItems="center"
      position="relative"
    >
      <motion.div
        style={{
          overflow: 'visible',
          height: '101%',
        }}
      >
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="101%"
          viewBox="-8 0 479 479.936"
          variants={projectVariants}
          initial="hidden"
          animate="visible"
          overflow="visible"
          style={{ opacity, y }}
        >
          <g
            stroke="currentColor"
            fill="none"
            strokeWidth={5}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {/* Rotate this one */}

            <motion.path
              stroke="#DD6B20"
              animate={{
                rotate: 180,
                transition: {
                  duration: 3,
                  repeat: Infinity,
                },
              }}
              style={{ scale }}
              d="m458.402344 318.585938-25.085938-6.273438c-2.097656-6.925781-4.882812-13.628906-8.3125-20l13.3125-22.183594c1.890625-3.148437 1.394532-7.179687-1.199218-9.777344l-24.96875-25c-2.597657-2.597656-6.628907-3.089843-9.777344-1.199218l-22.183594 13.3125c-2.878906-1.542969-5.839844-2.96875-8.855469-4.265625-3.65625-1.550781-7.394531-2.902344-11.199219-4.046875l-6.273437-25.089844c-.886719-3.5625-4.085937-6.0625-7.757813-6.0625h-35.289062c-3.671875 0-6.871094 2.5-7.761719 6.0625l-6.269531 25.089844c-6.929688 2.097656-13.628906 4.882812-20 8.3125l-22.183594-13.3125c-3.148437-1.890625-7.179687-1.398438-9.777344 1.199218l-25 24.96875c-2.597656 2.597657-3.089843 6.628907-1.199218 9.777344l13.3125 22.183594c-3.433594 6.371094-6.214844 13.070312-8.3125 20l-25.089844 6.269531c-3.5625.890625-6.0625 4.089844-6.0625 7.761719v35.3125c0 3.671875 2.5 6.871094 6.0625 7.757812l25.089844 6.273438c2.097656 6.925781 4.878906 13.625 8.3125 20l-13.3125 22.183594c-1.890625 3.148437-1.398438 7.179687 1.199218 9.777344l24.96875 24.96875c2.597657 2.59375 6.628907 3.089843 9.773438 1.199218l22.183594-13.3125c6.375 3.429688 13.074218 6.214844 20 8.3125l6.273437 25.085938c.890625 3.5625 4.089844 6.0625 7.761719 6.066406h35.3125c3.671875-.003906 6.871094-2.503906 7.757812-6.066406l6.273438-25.085938c6.925781-2.097656 13.625-4.882812 20-8.3125l22.183594 13.3125c3.148437 1.890625 7.179687 1.394532 9.777344-1.199218l24.964843-24.96875c2.597657-2.597657 3.09375-6.628907 1.203125-9.777344l-13.3125-22.183594c3.429688-6.375 6.214844-13.074219 8.3125-20l25.085938-6.273438c3.5625-.886718 6.0625-4.085937 6.0625-7.757812v-35.28125c.007812-3.652344-2.460938-6.847656-6-7.757812zm-9.933594 36.820312-23.542969 5.890625c-2.863281.710937-5.097656 2.933594-5.824219 5.792969-2.203124 8.667968-5.644531 16.972656-10.226562 24.652344-1.507812 2.53125-1.507812 5.683593 0 8.210937l12.496094 20.800781-16.101563 16.167969-20.800781-12.496094c-2.527344-1.511719-5.679688-1.511719-8.207031 0-7.683594 4.578125-15.988281 8.023438-24.65625 10.222657-2.859375.726562-5.082031 2.964843-5.792969 5.824218l-5.9375 23.527344h-22.816406l-5.886719-23.542969c-.710937-2.859375-2.9375-5.097656-5.792969-5.824219-8.667968-2.203124-16.972656-5.644531-24.65625-10.226562-2.527344-1.507812-5.679687-1.507812-8.207031 0l-20.800781 12.496094-16.167969-16.101563 12.496094-20.800781c1.511719-2.527344 1.511719-5.679688 0-8.207031-4.578125-7.683594-8.023438-15.988281-10.222657-24.65625-.726562-2.855469-2.964843-5.082031-5.824218-5.792969l-23.527344-5.9375v-22.8125l23.542969-5.890625c2.859375-.710937 5.097656-2.933594 5.824219-5.792969 2.199218-8.667968 5.644531-16.972656 10.222656-24.652344 1.511718-2.53125 1.511718-5.683593 0-8.210937l-12.496094-20.800781 16.105469-16.167969 20.800781 12.496094c2.527344 1.511719 5.679688 1.511719 8.207031 0 7.683594-4.578125 15.988281-8.023438 24.65625-10.222657 2.855469-.726562 5.082031-2.964843 5.792969-5.824218l5.933594-23.527344h22.816406l5.890625 23.542969c.710937 2.859375 2.933594 5.097656 5.789063 5.824219 8.667968 2.195312 16.972656 5.636718 24.648437 10.21875 2.53125 1.511718 5.6875 1.511718 8.21875 0l20.796875-12.496094 16.167969 16.109375-12.496094 20.800781c-1.507813 2.527344-1.507813 5.679688 0 8.207031 4.582031 7.683594 8.023437 15.988281 10.226563 24.65625.726562 2.855469 2.960937 5.082031 5.824218 5.792969l23.527344 5.9375zm0 0"
            />
            <motion.path
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
                transition: {
                  duration: 3,
                },
              }}
              stroke="#DD6B20"
              d="m328.46875 280c-35.347656 0-64 28.652344-64 64s28.652344 64 64 64c35.34375 0 64-28.652344 64-64-.039062-35.328125-28.671875-63.960938-64-64zm0 112c-26.511719 0-48-21.492188-48-48s21.488281-48 48-48c26.507812 0 48 21.492188 48 48-.027344 26.5-21.503906 47.972656-48 48zm0 0"
            />

            <motion.path
              variants={projectVariants}
              d="m32.46875 408v32c0 4.417969 3.582031 8 8 8h168v-16h-160v-24h96c1.238281.011719 2.460938-.261719 3.574219-.800781l32-16c2.714843-1.351563 4.433593-4.125 4.433593-7.160157 0-3.03125-1.71875-5.804687-4.433593-7.160156l-32-16c-1.105469-.566406-2.332031-.867187-3.574219-.878906h-96v-272h304c17.671875 0 32-14.328125 32-32v-16c0-4.417969-3.582031-8-8-8h-24v16h16v8c0 8.835938-7.164062 16-16 16s-16-7.164062-16-16v-24c0-8.835938 7.164062-16 16-16h32c8.835938 0 16 7.164062 16 16v184h16v-184c0-17.671875-14.328125-32-32-32h-352c-17.675781 0-32 14.328125-32 32v24c0 17.671875 14.324219 32 32 32v272h-8c-13.253906 0-24 10.746094-24 24s10.746094 24 24 24zm-16-352v-24c0-8.835938 7.164062-16 16-16h292.445312c-2.878906 4.84375-4.414062 10.367188-4.445312 16v24c.03125 5.632812 1.566406 11.15625 4.445312 16h-292.445312c-8.835938 0-16-7.164062-16-16zm142.109375 328-16 8h-6.109375v-16h6.109375zm-142.109375 0c0-4.417969 3.582031-8 8-8h96v16h-96c-4.417969 0-8-3.582031-8-8zm0 0"
            />
            <motion.path
              variants={projectVariants}
              style={{ x: xLeft, scale: scale, rotate: rotateLeft }}
              d="m.46875 120h16v160h-16zm0 0"
            />
            <motion.path
              style={{ x: xLeft, y: xLeft, scale: scale, rotate: rotateLeft }}
              variants={projectVariants}
              d="m312.46875 128v-16h-104c-2.121094 0-4.15625.84375-5.65625 2.34375l-14.617188 14.617188c-34.945312-25.613282-83.355468-21.875-113.953124 8.800781-3.121094 3.121093-3.121094 8.1875 0 11.308593l56.570312 56.570313c1.496094 1.503906 3.53125 2.355469 5.65625 2.359375h80c4.417969 0 8-3.582031 8-8-.007812-22.519531-8.679688-44.171875-24.226562-60.464844l11.539062-11.535156zm-104.449219 64h-68.238281l-48.257812-48.257812c24.59375-19.691407 59.15625-21.035157 85.207031-3.316407l-21.917969 21.917969 11.3125 11.3125 22.847656-22.847656c10.640625 11.308594 17.324219 25.761718 19.046875 41.191406zm0 0"
            />
            <motion.path
              style={{ x: xRight, y: xLeft, scale: scale }}
              variants={projectVariants}
              d="m328.46875 112h16v16h-16zm0 0"
            />
            <motion.path
              style={{ x: xLeft, scale: scale }}
              variants={projectVariants}
              d="m88.46875 232h16v16h-16zm0 0"
            />
            <motion.path
              style={{ x: xLeft, scale: scale, rotate: rotateLeft }}
              variants={projectVariants}
              d="m120.46875 232h80v16h-80zm0 0"
            />
            <motion.path
              style={{ x: xLeft, y: xRight, scale: scale, rotate: rotateRight }}
              variants={projectVariants}
              d="m72.46875 264h128v16h-128zm0 0"
            />
            <motion.path
              style={{ x: xRight, y: xLeft, scale: scale }}
              variants={projectVariants}
              d="m248.46875 144h16v16h-16zm0 0"
            />
            <motion.path
              style={{ x: xRight, y: xLeft, scale: scale, rotate: rotateRight }}
              variants={projectVariants}
              d="m280.46875 144h64v16h-64zm0 0"
            />
            <motion.path
              style={{ x: xRight, y: xRight, scale: scale, rotate: rotateLeft }}
              variants={projectVariants}
              d="m248.46875 176h96v16h-96zm0 0"
            />
            <motion.path
              style={{ x: xLeft, y: xRight, scale: scale, rotate: rotateLeft }}
              variants={projectVariants}
              d="m72.46875 296h104v16h-104zm0 0"
            />
          </g>
        </motion.svg>
      </motion.div>
    </MotionFlex>
  );
};
